import React from 'react';

/**
 * Toggle de rango temporal para el dashboard de Metricas.
 * Misma estetica que los toggles grid/lista de ProyectosHomeView:
 * outer rounded-lg con bg-slate-100/80 y los items rounded-md.
 */
const OPCIONES = [
  { key: 'semana',    label: 'Esta semana' },
  { key: 'mes',       label: 'Mes' },
  { key: 'trimestre', label: 'Trimestre' },
];

const RangoToggle = ({ value, onChange }) => {
  return (
    <div className="inline-flex items-center gap-0.5 p-0.5 bg-slate-100/80 rounded-lg">
      {OPCIONES.map((o) => {
        const active = o.key === value;
        return (
          <button
            key={o.key}
            onClick={() => onChange(o.key)}
            className={`px-2.5 py-1 text-xs font-medium rounded-md transition-colors ${
              active
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-500 hover:text-slate-800'
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default RangoToggle;
